/* Mobile menu burger toggle */
const menuOverlay = document.getElementById('menuOverlay');
const menu = document.querySelector(".menu");
const menuItems = document.querySelectorAll(".menuItem");
const hamburger= document.querySelector(".hamburger");
const closeIcon= document.querySelector(".closeIcon");
const menuIcon = document.querySelector(".menuIcon");

function toggleMenu() {
    if (menu.classList.contains("showMenu")) {
        menu.classList.remove("showMenu");
        closeIcon.style.display = "none";
        menuIcon.style.display = "block";
        menuOverlay.style.display = 'none';
    } else {
        menu.classList.add("showMenu");
        closeIcon.style.display = "block";
        menuIcon.style.display = "none";
        menuOverlay.style.display = 'block';
    }
}

hamburger.addEventListener("click", toggleMenu);

// Close the popup when clicking outside the overlay content
if(menuOverlay) {
    menuOverlay.addEventListener('click', function (event) {
        if (event.target === menuOverlay) {
            toggleMenu();
        }
    });
}

menuItems.forEach(
    function(menuItem) {
        menuItem.addEventListener("click", toggleMenu);
    }
)
